import { render } from "./WhyyouView.vue?vue&type=template&id=3a3fed34"
import script from "./WhyyouView.vue?vue&type=script&lang=js"
export * from "./WhyyouView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__